import UniversalCookies from 'universal-cookie';
import jwt_decode from 'jwt-decode';
import { cookies } from '@/data/constants';

const cookieStore = new UniversalCookies();

/**
 * Get PCID from access token cookie (if exists and valid)
 * @returns The PCID or undefined if not available
 */
export function getPcid(): string | undefined {
  const accessToken = cookieStore.get(cookies.CIAM_ACCESS_TOKEN);

  if (!accessToken) {
    return undefined;
  }

  try {
    const decoded = jwt_decode<{ pcid: string }>(accessToken);
    return decoded.pcid || undefined;
  } catch {
    return undefined;
  }
}
